export { default } from './InfoMessage';
